var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg20Upload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20-upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99129 1.1989C10.2786 0.933701 10.7214 0.933701 11.0087 1.1989L14.2587 4.1989C14.5631 4.47985 14.5821 4.95434 14.3011 5.25871C14.0202 5.56308 13.5457 5.58206 13.2413 5.3011L11.25 3.46299V12.25C11.25 12.6642 10.9142 13 10.5 13C10.0858 13 9.75 12.6642 9.75 12.25V3.46299L7.75871 5.3011C7.45434 5.58206 6.97985 5.56308 6.6989 5.25871C6.41794 4.95434 6.43692 4.47985 6.74129 4.1989L9.99129 1.1989ZM2.25 13C2.66421 13 3 13.3358 3 13.75V16.25C3 16.9404 3.55964 17.5 4.25 17.5H16.75C17.4404 17.5 18 16.9404 18 16.25V13.75C18 13.3358 18.3358 13 18.75 13C19.1642 13 19.5 13.3358 19.5 13.75V16.25C19.5 17.7688 18.2688 19 16.75 19H4.25C2.73122 19 1.5 17.7688 1.5 16.25V13.75C1.5 13.3358 1.83579 13 2.25 13Z",
    fill: "#182BCF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg20Upload);
export default __webpack_public_path__ + "static/media/20-upload.edaee01caae7a408e70900326259be4f.svg";
export { ForwardRef as ReactComponent };